module.exports = __webpack_public_path__ + "static/media/1292972-03a9f4.33569531.svg";